import { BancoService } from '@services/apis/financeiro/banco.service';
import { ComissionamentoService } from '@services/apis/financeiro/comissionamento.service';
import { ContaCorrenteService } from '@services/apis/financeiro/conta-corrente.service';
import { ContratoFinanceiroService } from '@services/apis/financeiro/contrato-financeiro.service';
import { ContratoPagamentoService } from './contrato-pagamento.service';
import { EnrollmentCreditService } from './enrollment-credit.service';
import { FinancialService } from '@services/apis/financeiro/financial.service';
import { FinanceiroResolver } from './resolvers/_financeiro-resolvers';
import { GerenciaNetService } from '@services/apis/financeiro/gerencianet.service';
import { ProdutoService } from '@services/apis/financeiro/produto.service';
import { VendaService } from './vendas.service';
import { PortalTransparenciaService } from './portal-transparencia.service';
import { CentroDeResultadoService } from './centro-de-resultado.service';
import { FormaPagamentoService } from './forma-pagamento.service';
import { GrupoLancamentoService } from './grupo-lancamento.service';
import { GrupoFinanceiroService } from './grupo-financeiro.service';
import { ItemService } from './item.service';
import { LancamentoCreditoService } from './lancamento-credito.service';
import { ModoPagamentoContaService } from './modo-pagamento-conta.service';
import { PessoaArquivoService } from './pessoa-arquivo.service';
import { PessoaEnderecoService } from './pessoa-endereco.service';
import { PessoaService } from './pessoa.service';
import { PrevisaoOrcamentariaService } from './previsao-orcamentaria.service';
import { ProdutoItemService } from './produto-item.service';
import { ProdutoPrecoService } from './produto-preco.service';
import { TipoCreditoService } from './tipo-credito.service';
import { TipoDeLancamentoService } from './tipo-de-lancamento.service';

export const FinanceiroServices = [
  BancoService,
  CentroDeResultadoService,
  ComissionamentoService,
  ContaCorrenteService,
  ContratoFinanceiroService,
  ContratoPagamentoService,
  EnrollmentCreditService,
  FinancialService,
  FormaPagamentoService,
  GerenciaNetService,
  GrupoLancamentoService,
  GrupoFinanceiroService,
  ItemService,
  LancamentoCreditoService,
  ModoPagamentoContaService,
  PessoaArquivoService,
  PessoaEnderecoService,
  PessoaService,
  PortalTransparenciaService,
  PrevisaoOrcamentariaService,
  ProdutoItemService,
  ProdutoPrecoService,
  ProdutoService,
  TipoCreditoService,
  TipoDeLancamentoService,
  VendaService,
  FinanceiroResolver
]
